import { type JSX, type ReactNode, useEffect } from "react";

import { APP_LOCAL_KEYS } from "@/app/constants/constants";

const sessionKeys = new Set<string>([
  APP_LOCAL_KEYS.TOKEN,
  APP_LOCAL_KEYS.CUSTOMER_ID,
  APP_LOCAL_KEYS.CUSTOMER_USER_ID,
  APP_LOCAL_KEYS.CUSTOMER_DATA,
  APP_LOCAL_KEYS.CUSTOMER_AUTH_USER,
  APP_LOCAL_KEYS.ADMIN_AS_CUSTOMER,
  APP_LOCAL_KEYS.IS_ADMIN_LOGIN_AS_CUSTOMER,
  APP_LOCAL_KEYS.WORKSPACE_DATA,
  APP_LOCAL_KEYS.WORKSPACE_ID,
  APP_LOCAL_KEYS.SUB_DOMAIN,
]);

export const StorageListener = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent): void => {
      if (event.key === null) {
        window.location.reload();

        return;
      }

      if (sessionKeys.has(event.key) && event.oldValue !== event.newValue) {
        window.location.reload();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return (): void =>
      window.removeEventListener("storage", handleStorageChange);
  }, []);

  return <>{children}</>;
};
